import GoogleMapReact from 'google-map-react';
import {useCallback, useState} from "react";
import Geocode from "react-geocode";
import Marker from "@/components/common/NewMap/Marker";
import {apiKey, defaultZoom, language, region} from "@/config/maps";

Geocode.setApiKey(apiKey)
Geocode.setRegion(region)

interface NewMapProps {
  onUpdateAddress: (param: UpdateAddressObject) => void
  lat: number
  lng: number
}

const NewMap: React.FC<NewMapProps> = ({ onUpdateAddress, lat, lng }) => {
  const [state, setState] = useState({
    mapApiLoaded: false,
    mapInstance: null,
    mapApi: null
  })
  const [searchBoxApi, setSearchBoxApi] = useState(null)
  const [searchString, setSearchString] = useState('')
  const [searchBox, setSearchBox] = useState(null)
  
  const handleApiLoaded = useCallback((map, maps) => {
    setState({
      mapApiLoaded: true,
      mapInstance: map,
      mapApi: maps
    })
  }, [])
  
  const updateAddressDataToParent = (geoObject, address) => {
    onUpdateAddress({
      address,
      lat: geoObject.lat,
      long: geoObject.lng
    })
  }
  
  const handlePlaceChanged = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      const selected = searchBoxApi.getPlaces()
      const {0: place} = selected;
      if (!place.geometry) return;
      if (place.geometry.viewport) {
        state.mapInstance.fitBounds(place.geometry.viewport);
      } else {
        state.mapInstance.setCenter(place.geometry.location);
        state.mapInstance.setZoom(17);
      }
      const geo = {
        lat: selected[0].geometry.location.lat(),
        lng: selected[0].geometry.location.lng()
      }
      updateAddressDataToParent(geo, selected[0].formatted_address)
    }
  }
  
  const handleOnClick = (ev) => {
    const geo = {
      lat: ev.lat,
      lng: ev.lng
    }
    Geocode.fromLatLng(`${ev.lat}`, `${ev.lng}`).then((response) => {
      const address = response.results[0].formatted_address;
      updateAddressDataToParent(geo, address)
    })
  }
  
  return (
    <>
      {
        state.mapApiLoaded &&
        <input
          ref={(ref) => {
            setSearchBox(ref)
          }}
          className="flex w-full items-center py-[8px] px-4 gap-2 border rounded border-solid border-stroke-subtle text-jsm font-normal"
          placeholder="Street name, area or address"
          onChange={(e) => {
            setSearchString(e.target.value)
            if (!searchBoxApi && searchBox) {
              const newNani = new state.mapApi.places.SearchBox(searchBox)
              setSearchBoxApi(newNani)
            }
          }}
          onKeyDown={handlePlaceChanged}
          value={searchString}
        />
      }
      <div style={{height: '100%', width: '100%'}}>
        <GoogleMapReact
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{
            region,
            language,
            key: apiKey,
            libraries: ['places', 'geometry'],
          }}
          onClick={handleOnClick}
          center={{
            lat,
            lng
          }}
          defaultZoom={defaultZoom}
          onGoogleApiLoaded={({map, maps}) => handleApiLoaded(map, maps)}
        >
          <Marker
            lat={lat}
            lng={lng}
          />
        </GoogleMapReact>
      </div>
    </>
  )
}

export default NewMap;